let handler= function(data,options={},before,after){
    let element={}
    for(var i=0;i<data.length;i++){
        element=before?before(data[i]):data[i]
        if(element[options.keys]&&element[options.keys].length){
            delete element[options.keys][0].id
            Object.assign(element,element[options.keys][0])

            if(element[options.keys].length<=1){

                delete  element[options.keys]
            }else{
                element[options.keys].splice(0,1)
                element[options.keys].forEach((value,index) => {
                // delete value.id
                let obj={}
                Object.keys(element).forEach((v)=> {
                    if(v!=options.keys){
                        if(v.indexOf('sn')==-1){
                            obj[v]=''
                        }else{
                            obj[v]=element[v]
                        }
                      
                        if(v=='stock_out_sn'||v=='to_sn'||v=='total_stock_out_num'||v=='total_real_stock_out_num'){
                            obj[v]=''
                            if(v=='stock_out_sn'){
                                obj.row_sn=element['stock_out_sn']
                            }
                        }
                    }
                });
                data.splice(i+index+1,0,Object.assign({},obj, value))
            });
            }
            }
    }
    console.log(data)
    return data 
} 
export default handler